<template>
	<div
		class="authentication"
		:style="`min-height: ${height ? height + 'px' : '100%'};`"
	>
		<Header title="实名认证" :haveHeight="true"></Header>
		<div class="wrap tip-wrap">
			<div class="tip">
				·按照法律法规要求，数字文创交易需要用户提供身份信息，请填写真实、有效的信息。
			</div>
			<div class="tip">
				·实名认证后即可正常购买并体验数字文创，请确认实名信息匹配。
			</div>
		</div>

		<div class="wrap common-wrap form-wrap">
			<div class="flex form-layer">
				<div class="form-label">真实姓名</div>
				<div class="flex layer-content">
					<input
						v-model="form.name"
						placeholder="请输入真实姓名"
						type="text"
						maxlength="18"
					/>
					<img
						v-if="form.name"
						@click="clear_input('name')"
						class="icon-close"
						src="https://oss01.dayou.art/tresor-auth-close.png"
					/>
				</div>
			</div>
			<div class="flex form-layer">
				<div class="form-label">身份证号</div>
				<div class="flex layer-content">
					<input
						v-model="form.id_number"
						placeholder="请输入身份证号"
						type="tel"
						maxlength="18"
					/>
					<img
						v-if="form.id_number"
						@click="clear_input('id_number')"
						class="icon-close"
						src="https://oss01.dayou.art/tresor-auth-close.png"
					/>
				</div>
			</div>
		</div>

		<div class="flex foot">
			<div
				:class="
					'common-button btn-authentication ' +
					(!can_authentication ? 'btn-authentication-diabled' : '')
				"
				@click="handle_authentication"
			>
				认证
			</div>
			<div class="flex agreement">
				<img
					class="check"
					:src="
						'https://oss01.dayou.art/' +
						(agreement ? 'tresor-checked.png' : 'tresor-check.png')
					"
					@click="switch_agreement"
				/>
				<div class="flex agreement-right">
					<div class="agreement-font1" @click="switch_agreement">
						我同意大有空间平台使用我提交的信息进行用户实名认证。
					</div>
					<div class="flex agreement-font1">
						具体协议查看
						<div
							class="agreement-font2"
							@click="to_agreement_serve"
						>
							《大有空间服务协议》
						</div>
						及
						<div
							class="agreement-font2"
							@click="to_agreement_privacy"
						>
							《大有空间隐私保护指引》
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
    non_login_idCard_verify,
    real_id,
} from '@/api/user';
export default {
	name: 'authentication',
	data() {
		return {
			tourist: false, // 是否为游客模式
			uid: '',
			// 用户信息
			form: {
				name: '',
				id_number: '',
			},
			agreement: false, // 是否勾选协议
			height: 0,
		};
	},
    computed: {
        // 是否可以进行认证
        can_authentication () {
            const arr = [this.form.name, this.form.id_number, this.agreement];
			return arr.every(item => !!item);
        }
    },
	created() {
		// 是否为游客模式
		const { tourist, uid } = this.$route.query;
		this.tourist = !!tourist;
		this.uid = uid;
		this.height = document.body.clientHeight;
	},
	methods: {
		// 校验姓名
		valid_name() {
			var regName = /^[\u4e00-\u9fa5]{2,4}$/;

			if (!regName.test(this.form.name)) {
				this.$toast({
					type: 'fail',
					message: '姓名填写有误',
				});
				return false;
			}

			return true;
		},

		// 校验身份证
		valid_idCard() {
			var regName = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

			if (!regName.test(this.form.id_number)) {
				this.$toast({
					type: 'fail',
					message: '身份证填写有误',
				});
				return false;
			}

			return true;
		},

		clear_input(key) {
			this.form[key] = '';
		},

		// 切换协议勾选状态
		switch_agreement() {
			this.agreement = !this.agreement;
		},

		// 认证
		handle_authentication() {
			if (!this.can_authentication) {
				return;
			}

			if (!this.valid_name() || !this.valid_idCard()) {
				return;
			}

			const form = this.tourist
				? { uid: this.uid, ...this.form }
				: this.form;
			const fnName = this.tourist ? non_login_idCard_verify : real_id;
			fnName(form).then(() => {
				this.$toast({
					type: 'success',
					message: '认证成功',
				});
				setTimeout(() => {
					this.$router.go(-1);
				}, 1500);
			});
		},

		// 服务协议
		to_agreement_serve() {
			this.$router.push({
				name: 'agreement',
			});
		},

		// 隐私协议
		to_agreement_privacy() {
			this.$router.push({
				name: 'privacy',
			});
		},
	},
};
</script>

<style lang="less" scoped>
@import './authentication.less';
</style>
>
